/**
*
* IconHolder
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import Background from 'assets/eye.svg';
import IconHolderWrapper from './styles/IconHolderWrapper';


const IconHolder = React.memo(function IconHolder(props) {

  const iconUrl = props.icon ? props.icon : Background;

  const {
    iconSize,
    iconFill,
    thisStyles,
    thisStylesWrapper,
    iconStyles,
    onClick
  } = props;

  return (
    <IconHolderWrapper 
      iconSize={iconSize} 
      thisStyles={thisStyles} 
      iconFill={iconFill}
      iconStyles={iconStyles}
      thisStylesWrapper={thisStylesWrapper}
      onClick={onClick}
    >
      <SVG
        src={iconUrl}
      >
      </SVG>
    </IconHolderWrapper>
  );
});

IconHolder.propTypes = {
  iconSize: PropTypes.string,
  icon: PropTypes.string,
  thisStyles: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  iconFill: PropTypes.string
};

export default IconHolder;
